"use strict";

exports.__esModule = true;
exports.stripUnit = stripUnit;
exports.em = em;

function stripUnit(value) {
  var unitlessValue = parseFloat(value);
  if (isNaN(unitlessValue)) return value;
  return unitlessValue;
}

function em(pxValue) {
  var unitlessValue = stripUnit(pxValue);
  return unitlessValue / 16 + "em";
}